module.exports = __webpack_public_path__ + "media/images/icons/ic-list-events-8e44b73db27c7250f9a1293f8403bae4.svg";